import { all_routes } from "../../../feature-module/router/all_routes";
import { useSelector } from "react-redux";
const routes = all_routes;

export const SidebarDataTest = () => {
  const user = useSelector((state: any) => {
    return state.user.user;
  });
  if (user) {
    const crmMenu = {
      tittle: "CRM",
      icon: "file",
      showAsTab: false,
      separateRoute: false,
      submenuItems: [
        {
          label: "Contacts",
          link: routes.contactGrid,
          submenu: false,
          showSubRoute: false,
          icon: "user-shield",
          base: "contact",
          materialicons: "confirmation_number",
          submenuItems: [],
        },

        {
          label: "Leads",
          link: routes.leadsGrid,
          submenu: false,
          showSubRoute: false,
          icon: "users",
          base: "leads",
          materialicons: "request_quote",
          submenuItems: [],
        },
        {
          label: "Leads Transfer",
          link: routes.leadsTransfer,
          submenu: false,
          showSubRoute: false,
          icon: "arrows-left-right",
          base: "leads",
          materialicons: "request_quote",
          submenuItems: [],
        },
        {
          label: "Deals",
          link: routes.dealsGrid,
          submenu: false,
          showSubRoute: false,
          icon: "briefcase",
          base: "deals",
          materialicons: "account_balance_wallet",
          submenuItems: [],
        },
        {
          label: "Deals Transfer",
          link: routes.dealsTransfer,
          submenu: false,
          showSubRoute: false,
          icon: "transfer",
          base: "deals",
          materialicons: "request_quote",
          submenuItems: [],
        },
        {
          label: "Live Call",
          link: routes.liveCall,
          submenu: false,
          showSubRoute: false,
          icon: "phone-call",
          base: "deals",
          materialicons: "call", // Material icon alternative
          submenuItems: [],
        },
        {
          label: "Call Logs",
          link: routes.callLogs,
          icon: "phone-incoming", // Tabler/Feather style
          submenu: true,
          showSubRoute: false,
          base: "leadform",
          materialicons: "request_quote",
          submenuItems:
            (user?.userDetails?.department_access == 0 &&
              user?.userDetails?.role_char.toLowerCase() == "employeeadmin") ||
              user?.userDetails?.role_char.toLowerCase() == "admin"
              ? [
                {
                  label: "Call Logs",
                  link: routes.callLogs,
                  submenu: false,
                  showSubRoute: false,
                  icon: "file-description",
                  base: "leadform",
                  materialicons: "request_quote",
                  submenuItems: [],
                },
                {
                  label: "Bulk Upload",
                  link: routes.bulkUpload,
                  submenu: false,
                  showSubRoute: false,
                  icon: "upload",
                  base: "leadform",
                  materialicons: "request_quote",
                  submenuItems: [],
                },
                {
                  label: "User Call",
                  link: routes.userCall,
                  submenu: false,
                  showSubRoute: false,
                  icon: "calendar-user",
                  base: "leadform",
                  materialicons: "request_quote",
                  submenuItems: [],
                },
              ]
              : [
                {
                  label: "Call Logs",
                  link: routes.callLogs,
                  submenu: false,
                  showSubRoute: false,
                  icon: "file-description",
                  base: "leadform",
                  materialicons: "request_quote",
                  submenuItems: [],
                },
                {
                  label: "User Call",
                  link: routes.userCall,
                  submenu: false,
                  showSubRoute: false,
                  icon: "calendar-user",
                  base: "leadform",
                  materialicons: "request_quote",
                  submenuItems: [],
                }
              ],
        },
        {
          label: "Leads In Queue",
          link: routes.leadsqueue,
          submenu: false,
          showSubRoute: false,
          icon: "clock-pause",
          base: "leads",
          materialicons: "request_quote",
          submenuItems: [],
        },
        {
          label: "CRM Settings",
          link: routes.crmSettings,
          submenu: false,
          showSubRoute: false,
          icon: "settings",
          base: "leadform",
          materialicons: "request_quote",
          submenuItems: [],
        },
        {
          label: "Pipelines",
          link: routes.pipeline,
          submenu: false,
          showSubRoute: false,
          icon: "chart-treemap",
          base: "pipeline",
          materialicons: "verified_user",
          submenuItems: [],
        },
        {
          label: "Leads Form",
          link: routes.leadsForm,
          submenu: false,
          showSubRoute: false,
          icon: "forms",
          base: "leadform",
          materialicons: "request_quote",
          submenuItems: [],
        },
        {
          label: "Facebook Connect",
          link: routes.facebookLeads,
          submenu: false,
          showSubRoute: false,
          icon: "link",
          base: "leads",
          materialicons: "request_quote",
          submenuItems: [],
        },
        {
          label: "WhatsApp Connect",
          link: routes.whatsAppLeads,
          submenu: false,
          showSubRoute: false,
          icon: "brand-whatsapp",
          base: "leads",
          materialicons: "request_quote",
          submenuItems: [],
        },
        {
          label: "Webhook Integration",
          displayLabel: "WhatsApp Connect",
          link: routes.webhookIntegrations,
          submenu: false,
          showSubRoute: false,
          icon: "webhook",
          base: "webhook-integrations",
          materialicons: "request_quote",
          submenuItems: [],
        },
      ],
    };

    const filteredCrmMenu = {
      ...crmMenu,
      submenuItems: crmMenu.submenuItems.filter((sub) =>
        user.userDetails?.menu_items?.includes(sub.label)
      ),
    };

    return [
      {
        tittle: "Main Menu",
        icon: "airplay",
        showAsTab: true,
        separateRoute: false,
        submenuItems: [
          {
            label: "Dashboard",
            link: "index",
            submenu: true,
            showSubRoute: false,
            icon: "layout-dashboard",
            base: "dashboard",
            materialicons: "start",
            submenuItems: [
              ...(user.userDetails.role_char.toLowerCase() === "admin" ||
                user.userDetails.role_char.toLowerCase() === "employeeadmin"
                ? [
                  {
                    label: "Dashboard",
                    link: routes.adminDashboard,
                    icon: "gauge",
                  },
                ]
                : [
                  {
                    label: "Dashboard",
                    link: routes.adminDashboard,
                    icon: "gauge",
                  },
                ]),
              // { label: "Employee Dashboard", link: routes.employeeDashboard },

              // ...(user.userDetails?.menu_items?.includes("Deals") &&
              // user.userDetails.role_char.toLowerCase() != "admin" &&
              // user.userDetails.role_char.toLowerCase() != "employeeadmin"
              //   ? [{ label: "Deals Dashboard", link: routes.dealsDashboard }]
              //   : []),
              // ...(user.userDetails?.menu_items?.includes("Leads") &&
              // user.userDetails.role_char.toLowerCase() != "admin" &&
              // user.userDetails.role_char.toLowerCase() != "employeeadmin"
              //   ? [{ label: "Leads Dashboard", link: routes.leadsDashboard }]
              //   : []),
            ],
          },
          {
            label: "Applications",
            link: "apps",
            submenu: true,
            showSubRoute: false,
            icon: "grid-dots",
            base: "application",
            materialicons: "dashboard",
            submenuItems: [
              // {
              //   label: "Chat",
              //   link: routes.chat,
              //   base: "chats",
              //   customSubmenuTwo: false,
              // },
              // {
              //   label: "Calls",
              //   customSubmenuTwo: true,
              //   submenu: true,
              //   showSubRoute: false,
              //   link: routes.voiceCall,
              //   page1: "voice-call",
              //   page2: "videocall",
              //   base: "calls",
              //   submenuItems: [
              //     {
              //       label: "Voice Call",
              //       link: routes.voiceCall,
              //       submenu: false,
              //       showSubRoute: false,
              //       base: "voice-call",
              //     },
              //     {
              //       label: "Video Call",
              //       link: routes.videoCall,
              //       submenu: false,
              //       showSubRoute: false,
              //       base: "video-call",
              //     },
              //     {
              //       label: "Outgoing Call",
              //       link: routes.outgoingCall,
              //       submenu: false,
              //       showSubRoute: false,
              //       base: "outgoing-call",
              //     },
              //     {
              //       label: "Incoming Call",
              //       link: routes.incomingCall,
              //       submenu: false,
              //       showSubRoute: false,
              //       base: "incoming-call",
              //     },
              //     {
              //       label: "Call History",
              //       link: routes.callHistory,
              //       submenu: false,
              //       showSubRoute: false,
              //       base: "call-history",
              //     },
              //   ],
              // },
              // {
              //   label: "Calendar",
              //   showSubRoute: false,
              //   link: routes.calendar,
              //   customSubmenuTwo: false,
              //   base: "calendar",
              // },

              {
                label: "Task Managment",
                showSubRoute: false,
                link: routes.TodoList,
                customSubmenuTwo: false,
                base: "todo",
                icon: "checklist",
                dot: false,
              },
              {
                label: "File Manager",
                showSubRoute: false,
                link: routes.fileManager,
                customSubmenuTwo: false,
                base: "file-manager",
                icon: "folder-open",
                dot: false,
              },
              {
                label: "Email",
                showSubRoute: false,
                link: routes.email,
                customSubmenuTwo: false,
                base: "email",
                icon: "mail",
                dot: false,
              },
              {
                label: "Chat",
                link: routes.chat,
                base: "chats",
                customSubmenuTwo: false,
                icon: "message-dots",
                dot: false,
              },
              {
                label: "Activity Calendar",
                link: routes.activityCalendar,
                base: "acitvity-calendar",
                customSubmenuTwo: false,
                icon: "calendar-week",
                dot: false,
              },

              // {
              //   label: "Email",
              //   showSubRoute: false,
              //   link: routes.email,
              //   customSubmenuTwo: false,
              //   base: "email",
              // },
              // {
              //   label: "Kanban",
              //   showSubRoute: false,
              //   link: routes.kanbanView,
              //   customSubmenuTwo: false,
              //   base: "kanban",
              // },
              // {
              //   label: "Invoices",
              //   showSubRoute: false,
              //   link: routes.invoice,
              //   customSubmenuTwo: false,
              //   base: "invoices",
              // },
            ],
          },
          {
            label: "Super Admin",
            link: "index",
            submenu: true,
            showSubRoute: false,
            icon: "user-star",
            base: "super-admin",
            materialicons: "",
            submenuItems: [
              {
                label: "Dashboard",
                link: routes.superAdminDashboard,
                base: "super-admin-dashboard",
              },
              {
                label: "Companies",
                link: routes.superAdminCompanies,
                base: "companies",
              },
              {
                label: "Subscriptions",
                link: routes.superAdminSubscriptions,
                base: "subscriptions",
              },
              {
                label: "Packages",
                link: routes.superAdminPackages,
                base: "packages",
                base2: "packages-grid",
              },
            ],
          },
        ],
      },
      //ERS
      {
        tittle: "ERS",
        icon: "file",
        showAsTab: false,
        separateRoute: false,
        submenuItems: [
          {
            label: "Reports",
            submenu: true,
            showSubRoute: false,
            icon: "report",
            materialicons: "people",
            submenuItems: [
              {
                label: "Overview",
                link: routes.ersReportsOverview,
                icon: "file-analytics me-1",
              },
            ],
          },
          {
            label: "Team Reports",
            submenu: true,
            showSubRoute: false,
            icon: "stack-front",
            materialicons: "people",
            submenuItems: [
              {
                label: "Overview",
                link: routes.ersTeamReportsOverview,
                icon: "file-analytics me-1",
              },
            ],
          },
          {
            label: "Reports Settings",
            submenu: true,
            showSubRoute: false,
            icon: "file-settings",
            materialicons: "people",
            submenuItems: [
              {
                label: "Report Types",
                link: routes.ersReportsSettingReportType,
                icon: "report-search me-1",
              },
            ],
          },
        ],
      },
      // AUTOMATIONS
      {
        tittle: "AUTOMATIONS",
        icon: "automation",
        showAsTab: false,
        separateRoute: false,
        submenuItems: [
          {
            label: "Assets Automation",
            submenu: false,
            showSubRoute: false,
            icon: "cube-send",
            materialicons: "people",
            link: routes.assetsAutomation,
          },
          {
            label: "Leads Automation",
            submenu: false,
            showSubRoute: false,
            icon: "headphones",
            materialicons: "people",
            link: routes.leadsAutomation,
          },
          // {
          //   label: "Deals Automation",
          //   submenu: false,
          //   showSubRoute: false,
          //   icon: "briefcase",
          //   materialicons: "people",
          //   link: routes.dealsAutomation,
          // },
          {
            label: "Attendance Automation",
            submenu: false,
            showSubRoute: false,
            icon: "calendar-check",
            materialicons: "people",
            link: routes.attendanceAutomation,
          },
          {
            label: "Tasks Automation",
            submenu: false,
            showSubRoute: false,
            icon: "checklist",
            materialicons: "people",
            link: routes.taskManagerAutomation,
          },
          {
            label: "Calendar Automation",
            submenu: false,
            showSubRoute: false,
            icon: "calendar",
            materialicons: "people",
            link: routes.calendarAutomation,
          },
          {
            label: "ERS Automation",
            submenu: false,
            showSubRoute: false,
            icon: "file-text",
            materialicons: "people",
            link: routes.employeeReportingAutomation,
          },
          {
            label: "Tickets Automation",
            submenu: false,
            showSubRoute: false,
            icon: "ticket",
            materialicons: "people",
            link: routes.ticketsAutomation,
          },
        ],
      },
      {
        tittle: "PROJECTS",
        icon: "briefcase",
        showAsTab: false,
        separateRoute: false,
        submenuItems: [
          {
            label: "Projects",
            link: routes.projectsList,
            submenu: false,
            showSubRoute: false,
            icon: "briefcase",
            base: "projects",
            materialicons: "topic",
            submenuItems: [],
          },
        ],
      },
      ...(filteredCrmMenu.submenuItems.length > 0
        ? [filteredCrmMenu] // kuch items allowed hain → CRM dikhega
        : []), // ek bhi allowed nahi → CRM hide
      {
        tittle: "HRM",
        icon: "file",
        showAsTab: false,
        separateRoute: false,
        submenuItems: [
          {
            label: "Employees",
            link: routes.employeeList,
            submenu: true,
            showSubRoute: false,
            icon: "users",
            base: "employees",
            materialicons: "people",
            submenuItems: [
              {
                label: "Employees List",
                link: routes.employeeList,
                base: "employees",
                base2: "employee-list",
                icon: "id-badge",
              },
              {
                label: "Departments",
                link: routes.departments,
                base: "building-community",
                icon: "building-community",
              },
              {
                label: "Designations",
                link: routes.designations,
                base: "designations",
                icon: "certificate",
              },
            ],
          },
          {
            label: "Analytics",
            link: routes.analyticsDashboard,
            icon: "chart-bar",
          },
          {
            label: "Tickets",
            link: "ticketList",
            submenu: true,
            showSubRoute: false,
            icon: "ticket",
            base: "tickets",
            materialicons: "leaderboard",
            submenuItems: [
              {
                label: "Tickets",
                link: routes.tickets,
                base: "ticket-list",
                icon: "ticket",
              },
              {
                label: "Assigned Tickets",
                link: routes.ticketsAssigned,
                base: "ticket-assigned",
                icon: "user-check",
              },
            ],
          },
          {
            label: "Mood Meter",
            link: "moodMeterList",
            submenu: true,
            showSubRoute: false,
            icon: "mood-smile",
            base: "mood-meter",
            materialicons: "mood",
            submenuItems: [
              {
                label: "Daily Check-in",
                link: routes.moodQuestionnaire,
                base: "mood-questionnaire",
                icon: "checklist",
              },
            ],
          },
          {
            label: "Mood Meter Entries",
            link: "moodMeterList",
            submenu: true,
            showSubRoute: false,
            icon: "chart-bar",
            base: "mood-meter-settings",
            materialicons: "settings",
            submenuItems: [
              {
                label: "Mood Entries",
                link: routes.moodMeter,
                base: "mood-meter-list",
                icon: "mood-smile",
              },
            ],
          },
          {
            label: "Mood Meter Settings",
            link: "moodMeterList",
            submenu: true,
            showSubRoute: false,
            icon: "settings",
            base: "mood-meter-settings",
            materialicons: "settings",
            submenuItems: [
              {
                label: "Manage Questions",
                link: routes.moodQuestions,
                base: "mood-questions",
                icon: "question-mark",
              },
            ],
          },
          {
            label: "Attendance (Admin)",
            link: "sales",
            submenu: true,
            showSubRoute: false,
            icon: "file-time",
            base: "sales",
            materialicons: "track_changes",
            submenuItems: [
              {
                label: "Leaves",
                link: routes.leaveadmin,
                submenu: false,
                showSubRoute: false,
                icon: "calendar-off",
              },
              {
                label: "Attendance",
                link: routes.attendanceadmin,
                base: "attendance-admin",
                customSubmenuTwo: false,
                icon: "calendar-check",
              },
              {
                label: "Payroll Report",
                link: routes.payrollReport,
                base: "payroll-report",
                submenu: false,
                showSubRoute: false,
                icon: "file-spreadsheet",
              }
            ],
          },
          {
            label: "Attendance (Employee)",
            link: "sales",
            submenu: true,
            showSubRoute: false,
            icon: "file-time",
            base: "sales",
            materialicons: "track_changes",
            submenuItems: [
              {
                label: "Leaves",
                link: routes.leaveemployee,
                submenu: false,
                showSubRoute: false,
                icon: "calendar-off",
              },
              {
                label: "Attendance",
                link: routes.attendanceemployee,
                base: "attendance-employee",
                customSubmenuTwo: false,
                icon: "calendar-check",
              },
            ],
          },
          {
            label: "Attendance Settings",
            link: "sales",
            submenu: true,
            showSubRoute: false,
            icon: "file-time",
            base: "sales",
            materialicons: "track_changes",
            submenuItems: [
              {
                label: "Leave Setting",
                link: routes.leavesettings,
                base: "attendance-employee",
                customSubmenuTwo: false,
                icon: "calendar-off",
              },
              {
                label: "Attendance Setting",
                link: routes.settings,
                base: "attendance-employee",
                customSubmenuTwo: false,
                icon: "calendar-check",
              },
              {
                label: "Holiday Upload",
                link: routes.holidayUpload,
                base: "attendance-employee",
                customSubmenuTwo: false,
                icon: "calendar-plus",
              },
            ],
          },
        ],
      },
      {
        tittle: "RECRUITMENT",
        icon: "file",
        showAsTab: false,
        separateRoute: false,
        submenuItems: [
          {
            label: "Jobs",
            link: routes.jobgrid,
            submenu: false,
            showSubRoute: false,
            icon: "briefcase",
            base: "jobs",
            materialicons: "work",
            submenuItems: [],
          },
          {
            label: "Applications",
            link: routes.applicationsList,
            submenu: false,
            showSubRoute: false,
            icon: "user-check",
            base: "applications",
            materialicons: "assignment_ind",
            submenuItems: [],
          },
          {
            label: "Candidates",
            link: routes.recruitmentCandidatesList,
            submenu: false,
            showSubRoute: false,
            icon: "users",
            base: "candidates",
            materialicons: "people",
            submenuItems: [],
          },
          {
            label: "Interviews",
            link: routes.interviewList,
            submenu: false,
            showSubRoute: false,
            icon: "calendar-event",
            base: "interviews",
            materialicons: "calendar_today",
            submenuItems: [],
          },
          {
            label: "Refer Candidates",
            link: routes.referCandidates,
            submenu: false,
            showSubRoute: false,
            icon: "user-plus",
            base: "refer-candidates",
            materialicons: "person_add",
            submenuItems: [],
          },
          {
            label: "Referral Management",
            link: routes.refferal,
            submenu: false,
            showSubRoute: false,
            icon: "share",
            base: "referrals",
            materialicons: "share",
            submenuItems: [],
          },
          {
            label: "Hiring Setting",
            link: routes.hiringSetting,
            submenu: false,
            showSubRoute: false,
            icon: "settings",
            base: "recruitment-settings",
            materialicons: "settings",
            submenuItems: [],
          },
        ],
      },
      {
        tittle: "Finance & Accounts",
        icon: "file",
        showAsTab: false,
        separateRoute: false,
        submenuItems: [
          {
            label: "Sales",
            base: "sales",
            submenu: true,
            showSubRoute: false,
            icon: "shopping-cart-dollar",
            submenuItems: [
              {
                label: "Estimates",
                link: routes.estimate,
                base: "estimates",
              },
              {
                label: "Invoices",
                link: routes.invoices,
                base: "invoices",
              },
              {
                label: "Payments",
                link: routes.payments,
                base: "payments",
              },
              {
                label: "Expenses",
                link: routes.expenses,
                base: "expenses",
              },
              {
                label: "Provident Fund",
                link: routes.providentfund,
                base: "provident-fund",
              },
              {
                label: "Taxes",
                link: routes.taxes,
                base: "taxes",
              },
            ],
          },
          {
            label: "Accounting",
            base: "accounting",
            submenu: true,
            showSubRoute: false,
            icon: "file-dollar",
            submenuItems: [
              {
                label: "Categories",
                link: routes.categories,
                base: "categories",
              },
              {
                label: "Budgets",
                link: routes.budgets,
                base: "budgets",
              },
              {
                label: "Budget Expenses",
                link: routes.budgetexpenses,
                base: "budget-expenses",
              },
              {
                label: "Budget Revenues",
                link: routes.budgetrevenues,
                base: "budget-revenues",
              },
            ],
          },
          {
            label: "Payroll",
            base: "payroll",
            submenu: true,
            showSubRoute: false,
            icon: "cash",
            submenuItems: [
              {
                label: "Employee Salary",
                link: routes.employeesalary,
                base: "employee-salary",
              },
              {
                label: "Payslip",
                link: routes.payslip,
                base: "payslip",
              },
              {
                label: "Payroll Items",
                link: routes.payrollAddition,
                base: "payroll-items",
              },
            ],
          },
        ],
      },
      {
        tittle: "Administration",
        showAsTab: false,
        separateRoute: false,
        submenuItems: [
          {
            label: "Assets",
            base: "assets",
            submenu: true,
            showSubRoute: false,
            icon: "cash",
            submenuItems:
              user?.userDetails?.department_access == 0 &&
                user?.userDetails?.role_char.toLowerCase() == "employeeadmin"
                ? [
                  {
                    label: "Asset Stocks",
                    link: routes.assetStocks,
                    base: "asset-stocks",
                    icon: "box-seam me-1",
                  },
                  {
                    label: "Asset Products",
                    link: routes.assetProducts,
                    base: "asset-products",
                    icon: "package me-1",
                  },
                ]
                : [
                  {
                    label: "Asset Stocks",
                    link: routes.assetStocks,
                    base: "asset-stocks",
                    icon: "box-seam me-1",
                  },
                  {
                    label: "Assign Assets",
                    link: routes.assignAssets,
                    base: "assign-assets",
                    icon: "box-margin me-1",
                  },
                  {
                    label: "Asset Categories",
                    link: routes.assetCategories,
                    base: "asset-categories",
                    icon: "category me-1",
                  },
                  {
                    label: "Asset Products",
                    link: routes.assetProducts,
                    base: "asset-products",
                    icon: "package me-1",
                  },
                  {
                    label: "Asset Locations",
                    link: routes.assetLocations,
                    base: "asset-locations",
                    icon: "map-pin me-1",
                  },
                ],
          },
          ,
          {
            label: "Companies",
            link: routes.companiesList,
            submenu: false,
            showSubRoute: false,
            icon: "building",
            base: "company",
            materialicons: "shopping_bag",
            submenuItems: [],
          },
          {
            label: "Ticket Settings",
            base: "ticket-details",
            submenu: true,
            showSubRoute: false,
            icon: "cash",
            submenuItems: [
              {
                label: "Tickets Category",
                link: routes.ticketCategories,
                base: "ticket-details",
                icon: "category",
              },
            ],
          },
          {
            label: "Help & Supports",
            base: "supports",
            submenu: true,
            showSubRoute: false,
            icon: "headset",
            submenuItems: [
              {
                label: "Knowledge Base",
                link: routes.knowledgebase,
                base: "knowledgebase",
                base2: "knowledgebase-view",
                base3: "knowledgebase-details",
              },
              {
                label: "Activities",
                link: routes.activity,
                base: "activities",
              },
            ],
          },
          {
            label: "User Management",
            base: "user-management",
            submenu: true,
            showSubRoute: false,
            icon: "user-star",
            submenuItems: [
              {
                label: "Users",
                link: routes.users,
                base: "users",
              },
              {
                label: "Roles & Permissions",
                link: routes.rolePermission,
                base: "roles-permissions",
              },
            ],
          },
          {
            label: "Settings",
            submenu: true,
            showSubRoute: false,
            icon: "settings",
            base: "settings",
            submenuItems: [
              {
                label: "General Settings",
                customSubmenuTwo: true,
                base: "general-settings",
                submenuItems: [
                  {
                    label: "Profile",
                    link: routes.profilesettings,
                    base: "profile-settings",
                    submenu: false,
                    showSubRoute: false,
                  },
                  {
                    label: "Security",
                    link: routes.securitysettings,
                    base: "security-settings",
                    submenu: false,
                    showSubRoute: false,
                  },
                  {
                    label: "Notifications",
                    link: routes.notificationssettings,
                    base: "notification-settings",
                    submenu: false,
                    showSubRoute: false,
                  },
                  {
                    label: "Connected Apps",
                    link: routes.connectedApps,
                    base: "connected-apps",
                    submenu: false,
                    showSubRoute: false,
                  },
                ],
              },
              {
                label: "Website Settings",
                customSubmenuTwo: true,
                base: "website-settings",
                submenuItems: [
                  {
                    label: "Business Settings",
                    link: routes.bussinessSettings,
                    base: "bussiness-settings",
                  },
                  {
                    label: "SEO Settings",
                    link: routes.seoSettings,
                    base: "seo-settings",
                  },
                  {
                    label: "Localization",
                    link: routes.localizationSettings,
                    base: "localization-settings",
                  },
                  {
                    label: "Prefixes",
                    link: routes.prefixes,
                    base: "prefixes",
                  },
                  {
                    label: "Preferences",
                    link: routes.preference,
                    base: "preferences",
                  },
                  {
                    label: "Appearance",
                    link: routes.appearance,
                    base: "appearance",
                  },
                  {
                    label: "Language",
                    link: routes.language,
                    base: "language",
                    base2: "add-language",
                  },
                  {
                    label: "Authentication",
                    link: routes.authenticationSettings,
                    base: "authentication-settings",
                  },
                  {
                    label: "AI Settings",
                    link: routes.aiSettings,
                    base: "ai-settings",
                  },
                ],
              },
              {
                label: "App Settings",
                customSubmenuTwo: true,
                base: "app-settings",
                submenuItems: [
                  {
                    label: "Salary Settings",
                    link: routes.salarySettings,
                    base: "salary-settings",
                  },
                  {
                    label: "Approval Settings",
                    link: routes.approvalSettings,
                    base: "approval-settings",
                  },
                  {
                    label: "Invoice Settings",
                    link: routes.invoiceSettings,
                    base: "invoice-settings",
                  },
                  {
                    label: "Leave Type",
                    link: routes.leaveType,
                    base: "leave-type",
                  },
                  {
                    label: "Custom Fields",
                    link: routes.customFields,
                    base: "custom-fields",
                  },
                ],
              },
              {
                label: "System Settings",
                customSubmenuTwo: true,
                base: "system-settings",
                submenuItems: [
                  {
                    label: "Email Settings",
                    link: routes.emailSettings,
                    base: "email-settings",
                  },
                  {
                    label: "Email Templates",
                    link: routes.emailTemplates,
                    base: "email-template",
                  },
                  {
                    label: "SMS Settings",
                    link: routes.smsSettings,
                    base: "sms-settings",
                  },
                  {
                    label: "SMS Templates",
                    link: routes.smsTemplate,
                    base: "sms-template",
                  },
                  {
                    label: "OTP",
                    link: routes.otpSettings,
                    base: "otp-settings",
                  },
                  {
                    label: "GDPR Cookies",
                    link: routes.gdprCookies,
                    base: "gdpr",
                  },
                  {
                    label: "Maintenance Mode",
                    link: routes.maintenanceMode,
                    base: "maintenance-mode",
                  },
                ],
              },
              {
                label: "Financial Settings",
                customSubmenuTwo: true,
                base: "financial-settings",
                submenuItems: [
                  {
                    label: "Payment Gateways",
                    link: routes.paymentGateways,
                    base: "payment-gateways",
                  },
                  {
                    label: "Tax Rate",
                    link: routes.taxRates,
                    base: "tax-rates",
                  },
                  {
                    label: "Currencies",
                    link: routes.currencies,
                    base: "currencies",
                  },
                ],
              },
              {
                label: "Other Settings",
                customSubmenuTwo: true,
                base: "other-settings",
                submenuItems: [
                  {
                    label: "Custom CSS",
                    link: routes.customCss,
                    base: "custom-css",
                  },
                  {
                    label: "Custom JS",
                    link: routes.customJs,
                    base: "custom-js",
                  },
                  {
                    label: "Cronjob",
                    link: routes.cronjob,
                    base: "cronjob",
                  },
                  {
                    label: "Storage",
                    link: routes.storage,
                    base: "storage-settings",
                  },
                  {
                    label: "Ban IP Address",
                    link: routes.banIpAddress,
                    base: "ban-ip-address",
                  },
                  {
                    label: "Backup",
                    link: routes.backup,
                    base: "backup",
                  },
                  {
                    label: "Clear Cache",
                    link: routes.clearcache,
                    base: "clear-cache",
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        tittle: "Content",
        showAsTab: false,
        separateRoute: false,
        submenuItems: [
          {
            label: "Pages",
            link: routes.pages,
            base: "pages",
            submenu: false,
            showSubRoute: false,
            icon: "box-multiple",
            submenuItems: [],
          },
          {
            label: "Blogs",
            submenu: true,
            showSubRoute: false,
            icon: "brand-blogger",
            base: "blogs",
            submenuItems: [
              {
                label: "All Blogs",
                link: routes.blogs,
                base2: "All Blogs",
              },
              {
                label: "Categories",
                link: routes.blogCategories,
                base: "/blog-categories",
              },
              {
                label: "Comments",
                link: routes.blogComments,
                base: "/blog-comments",
              },
              {
                label: "Blog Tags",
                link: routes.blogTags,
                base: "/blog-tags",
              },
            ],
          },
          {
            label: "Locations",
            submenu: true,
            showSubRoute: false,
            icon: "map-pin-check",
            base: "location",
            submenuItems: [
              {
                label: "Countries",
                link: routes.countries,
                base: "countries",
              },
              {
                label: "States",
                link: routes.states,
                base: "states",
              },
              {
                label: "Cities",
                link: routes.cities,
                base: "cities",
              },
            ],
          },
          {
            label: "Testimonials",
            link: routes.testimonials,
            base: "testimonials",
            submenu: false,
            showSubRoute: false,
            icon: "message-2",
            submenuItems: [],
          },
          {
            label: "FAQ’S",
            link: routes.faq,
            base: "faq",
            submenu: false,
            showSubRoute: false,
            icon: "question-mark",
            submenuItems: [],
          },
        ],
      },
      {
        tittle: "Pages",
        showAsTab: false,
        separateRoute: false,
        submenuItems: [
          {
            label: "Starter",
            link: routes.starter,
            base: "starter",
            submenu: false,
            showSubRoute: false,
            icon: "layout-sidebar",
            submenuItems: [],
          },
          {
            label: "Profile",
            link: routes.profile,
            base: "profile",
            submenu: false,
            showSubRoute: false,
            icon: "user-circle",
            submenuItems: [],
          },
          {
            label: "Gallery",
            link: routes.gallery,
            base: "gallery",
            submenu: false,
            showSubRoute: false,
            icon: "photo",
            submenuItems: [],
          },
          {
            label: "Search Results",
            link: routes.searchresult,
            base: "search-result",
            submenu: false,
            showSubRoute: false,
            icon: "list-search",
            submenuItems: [],
          },
          {
            label: "Timeline",
            link: routes.timeline,
            base: "timeline",
            submenu: false,
            showSubRoute: false,
            icon: "timeline",
            submenuItems: [],
          },
          {
            label: "Pricing",
            link: routes.pricing,
            base: "pricing",
            submenu: false,
            showSubRoute: false,
            icon: "file-dollar",
            submenuItems: [],
          },
          {
            label: "Coming Soon",
            link: routes.comingSoon,
            base: "coming-soon",
            submenu: false,
            showSubRoute: false,
            icon: "progress-bolt",
            submenuItems: [],
          },
          {
            label: "Under Maintenance",
            link: routes.underMaintenance,
            base: "under-maintenance",
            submenu: false,
            showSubRoute: false,
            icon: "alert-octagon",
            submenuItems: [],
          },
          {
            label: "Under Construction",
            link: routes.underConstruction,
            base: "under-construction",
            submenu: false,
            showSubRoute: false,
            icon: "barrier-block",
            submenuItems: [],
          },
          {
            label: "API Keys",
            link: routes.apikey,
            base: "api-keys",
            submenu: false,
            showSubRoute: false,
            icon: "api",
            submenuItems: [],
          },
          {
            label: "Privacy Policy",
            link: routes.privacyPolicy,
            base: "privacy-policy",
            submenu: false,
            showSubRoute: false,
            icon: "file-description",
            submenuItems: [],
          },
          {
            label: "Terms & Conditions",
            link: routes.termscondition,
            base: "terms-condition",
            submenu: false,
            showSubRoute: false,
            icon: "file-check",
            submenuItems: [],
          },
        ],
      },
      {
        tittle: "Authentication",
        showAsTab: false,
        separateRoute: false,
        submenuItems: [
          {
            label: "Login",
            submenu: true,
            showSubRoute: false,
            icon: "login",
            submenuItems: [
              {
                label: "Cover",
                link: routes.login,
              },
              {
                label: "Illustration",
                link: routes.login2,
              },
              {
                label: "Basic",
                link: routes.login3,
              },
            ],
          },
          {
            label: "Register",
            submenu: true,
            showSubRoute: false,
            icon: "forms",
            submenuItems: [
              {
                label: "Cover",
                link: routes.register,
              },
              {
                label: "Illustration",
                link: routes.register2,
              },
              {
                label: "Basic",
                link: routes.register3,
              },
            ],
          },
          {
            label: "Forgot Password",
            submenu: true,
            showSubRoute: false,
            icon: "help-triangle",
            submenuItems: [
              {
                label: "Cover",
                link: routes.forgotPassword,
              },
              {
                label: "Illustration",
                link: routes.forgotPassword2,
              },
              {
                label: "Basic",
                link: routes.forgotPassword3,
              },
            ],
          },
          {
            label: "Reset Password",
            submenu: true,
            showSubRoute: false,
            icon: "restore",
            submenuItems: [
              {
                label: "Cover",
                link: routes.resetPassword,
              },
              {
                label: "Illustration",
                link: routes.resetPassword2,
              },
              {
                label: "Basic",
                link: routes.resetPassword3,
              },
            ],
          },
          {
            label: "Email Verification",
            submenu: true,
            showSubRoute: false,
            icon: "mail-exclamation",
            submenuItems: [
              {
                label: "Cover",
                link: routes.emailVerification,
              },
              {
                label: "Illustration",
                link: routes.emailVerification2,
              },
              {
                label: "Basic",
                link: routes.emailVerification3,
              },
            ],
          },
          {
            label: "2 Step Verification",
            submenu: true,
            showSubRoute: false,
            icon: "password",
            submenuItems: [
              {
                label: "Cover",
                link: routes.twoStepVerification,
              },
              {
                label: "Illustration",
                link: routes.twoStepVerification2,
              },
              {
                label: "Basic",
                link: routes.twoStepVerification3,
              },
            ],
          },
          {
            label: "Lock Screen",
            link: routes.lockScreen,
            submenu: false,
            showSubRoute: false,
            icon: "lock-square",
            submenuItems: [],
          },
          {
            label: "404 Error",
            link: routes.error404,
            submenu: false,
            showSubRoute: false,
            icon: "error-404",
            submenuItems: [],
          },
          {
            label: "500 Error",
            link: routes.error500,
            submenu: false,
            showSubRoute: false,
            icon: "server",
            submenuItems: [],
          },
        ],
      },
      {
        tittle: "UI Interface",
        icon: "file",
        showAsTab: false,
        separateRoute: false,
        submenuItems: [
          {
            label: "Base UI",
            link: "index",
            submenu: true,
            showSubRoute: false,
            icon: "hierarchy-2",
            base: "base-ui",
            materialicons: "description",
            submenuItems: [
              {
                label: "Alerts",
                link: routes.alert,
                base: "ui-alerts",
              },
              {
                label: "Accordions",
                link: routes.accordion,
                base: "ui-accordion",
              },
              { label: "Avatar", link: routes.avatar, base: "ui-avatar" },
              { label: "Badges", link: routes.badges, base: "ui-badges" },
              { label: "Borders", link: routes.border, base: "ui-borders" },
              {
                label: "Buttons",
                link: routes.button,
                base: "ui-buttons",
              },
              {
                label: "Button Group",
                link: routes.buttonGroup,
                base: "ui-buttons-group",
              },
              {
                label: "Breadcrumb",
                link: routes.breadcrums,
                base: "ui-breadcrumb",
              },
              { label: "Cards", link: routes.cards, base: "ui-cards" },
              {
                label: "Carousel",
                link: routes.carousel,
                base: "ui-carousel",
              },
              {
                label: "Colors",
                link: routes.colors,
                base: "ui-colors",
              },
              {
                label: "Dropdowns",
                link: routes.dropdowns,
                base: "ui-dropdowns",
              },
              { label: "Grid", link: routes.grid, base: "ui-grid" },
              { label: "Images", link: routes.images, base: "ui-images" },
              {
                label: "Lightbox",
                link: routes.lightbox,
                base: "ui-lightbox",
              },
              { label: "Media", link: routes.media, base: "ui-media" },
              { label: "Modals", link: routes.modals, base: "ui-modals" },
              {
                label: "Offcanvas",
                link: routes.offcanvas,
                base: "ui-offcanvas",
              },
              {
                label: "Pagination",
                link: routes.pagination,
                base: "ui-pagination",
              },

              {
                label: "Progress Bars",
                link: routes.progress,
                base: "ui-progress",
              },
              {
                label: "Placeholders",
                link: routes.placeholder,
                base: "ui-placeholders",
              },

              {
                label: "Spinner",
                link: routes.spinner,
                base: "ui-spinner",
              },
              {
                label: "Range Slider",
                link: routes.rangeSlider,
                base: "ui-rangeslider",
              },

              { label: "Toasts", link: routes.toasts, base: "ui-toasts" },
              {
                label: "Tooltip",
                link: routes.tooltip,
                base: "ui-tooltips",
              },
              {
                label: "Typography",
                link: routes.typography,
                base: "ui-typography",
              },
              { label: "Videos", link: routes.video, base: "ui-video" },
              { label: "Sortable", link: routes.sortable, base: "ui-sortable" },
              { label: "SwiperJs", link: routes.swiperjs, base: "ui-swiperjs" },
            ],
          },
          {
            label: "Advanced Ui",
            submenu: true,
            showSubRoute: false,
            base: "advancedUi",
            icon: "hierarchy-3",
            materialicons: "sync_alt",
            submenuItems: [
              { label: "Ribbon", link: routes.ribbon, base: "ui-ribbon" },
              {
                label: "Clipboard",
                link: routes.clipboard,
                base: "ui-clipboard",
              },
              {
                label: "Drag & Drop",
                link: routes.dragandDrop,
                base: "ui-drag-drop",
              },
              {
                label: "Rating",
                link: routes.rating,
                base: "ui-rating",
              },
              {
                label: "Text Editor",
                link: routes.textEditor,
                base: "ui-text-editor",
              },
              {
                label: "Counter",
                link: routes.counter,
                base: "ui-counter",
              },
              {
                label: "Scrollbar",
                link: routes.scrollBar,
                base: "ui-scrollbar",
              },
              {
                label: "Timeline",
                link: routes.timeLine,
                base: "ui-timeline",
              },
            ],
          },
          {
            label: "Charts",
            submenu: true,
            showSubRoute: false,
            base: "charts",
            icon: "chart-line",
            materialicons: "library_add_check",
            submenuItems: [
              {
                label: "Apex Charts",
                link: routes.apexChart,
                base: "apex-charts",
              },
              {
                label: "Prime Charts",
                link: routes.primeChart,
                base: "prime-charts",
              },
              {
                label: "Chart JS",
                link: routes.chartJs,
                base: "chart-js",
              },
            ],
          },
          {
            label: "Icons",
            submenu: true,
            showSubRoute: false,
            icon: "icons",
            base: "icon",
            materialicons: "people",
            submenuItems: [
              {
                label: "Fontawesome Icons",
                link: routes.fontawesome,
                base: "icon-fontawesome",
              },
              {
                label: "Bootstrap Icons",
                link: routes.bootstrapIcons,
                base: "icon-bootstrap",
              },
              {
                label: "Remix Icons",
                link: routes.RemixIcons,
                base: "icon-remix",
              },
              {
                label: "Feather Icons",
                link: routes.featherIcons,
                base: "icon-feather",
              },
              {
                label: "Ionic Icons",
                link: routes.iconicIcon,
                base: "icon-ionic",
              },
              {
                label: "Material Icons",
                link: routes.materialIcon,
                base: "icon-material",
              },
              { label: "pe7 Icons", link: routes.pe7icon, base: "icon-pe7" },
              {
                label: "Simpleline Icons",
                link: routes.simpleLineIcon,
                base: "icon-simple-line",
              },
              {
                label: "Themify Icons",
                link: routes.themifyIcon,
                base: "icon-themify",
              },
              {
                label: "Weather Icons",
                link: routes.weatherIcon,
                base: "icon-weather",
              },
              {
                label: "Typicon Icons",
                link: routes.typicon,
                base: "icon-typicon",
              },
              {
                label: "Flag Icons",
                link: routes.FlagIcons,
                base: "icon-flag",
              },
            ],
          },
          {
            label: "Forms",
            icon: "input-search",
            base: "forms",
            submenu: true,
            showSubRoute: false,
            materialicons: "view_day",
            submenuItems: [
              {
                label: "Form Elements",
                base: "form-elements",
                customSubmenuTwo: true,
                submenu: true,
                showSubRoute: false,
                submenuItems: [
                  {
                    label: "Basic Inputs",
                    link: routes.basicInput,
                    submenu: false,
                    showSubRoute: false,
                    base: "form-basic-inputs",
                  },
                  {
                    label: "Checkbox & Radios",
                    link: routes.checkboxandRadion,
                    submenu: false,
                    showSubRoute: false,
                    base: "form-checkbox-radios",
                  },
                  {
                    label: "Input Groups",
                    link: routes.inputGroup,
                    submenu: false,
                    showSubRoute: false,
                    base: "form-input-groups",
                  },
                  {
                    label: "Grid & Gutters",
                    link: routes.gridandGutters,
                    submenu: false,
                    showSubRoute: false,
                    base: "form-grid-gutters",
                  },
                  {
                    label: "Form Select",
                    link: routes.formSelect,
                    submenu: false,
                    showSubRoute: false,
                    base: "form-select",
                  },
                  {
                    label: "Input Masks",
                    link: routes.formMask,
                    submenu: false,
                    showSubRoute: false,
                    base: "form-mask",
                  },
                  {
                    label: "File Uploads",
                    link: routes.fileUpload,
                    submenu: false,
                    showSubRoute: false,
                    base: "form-fileupload",
                  },
                ],
              },
              {
                label: "Layouts",
                customSubmenuTwo: true,
                base: "layouts",
                submenu: true,
                showSubRoute: false,
                submenuItems: [
                  {
                    label: "Horizontal Form",
                    link: routes.horizontalForm,
                    submenu: false,
                    showSubRoute: false,
                    base: "form-horizontal",
                  },
                  {
                    label: "Vertical Form",
                    link: routes.verticalForm,
                    submenu: false,
                    showSubRoute: false,
                    base: "form-vertical",
                  },
                  {
                    label: "Floating Labels",
                    link: routes.floatingLable,
                    submenu: false,
                    showSubRoute: false,
                    base: "form-floating-labels",
                  },
                ],
              },
              {
                label: "Form Validation",
                link: routes.formValidation,
                submenu: false,
                showSubRoute: false,
                customSubmenuTwo: false,
                base: "form-validation",
              },
              {
                label: "Form Wizard",
                link: routes.formWizard,
                submenu: false,
                showSubRoute: false,
                customSubmenuTwo: false,
                base: "form-wizard",
              },
              {
                label: "Form Picker",
                link: routes.formPicker,
                submenu: false,
                showSubRoute: false,
                customSubmenuTwo: false,
                base: "form-picker",
              },
            ],
          },
          {
            label: "Tables",
            link: "tables",
            submenu: true,
            showSubRoute: false,
            icon: "table",
            base: "tables",
            materialicons: "table_rows",
            submenuItems: [
              {
                label: "Basic Tables",
                link: routes.tablesBasic,
                base: "tables-basic",
              },
              {
                label: "Data Tables",
                link: routes.dataTables,
                base: "data-basic",
              },
            ],
          },
          {
            label: "Maps",
            submenu: true,
            showSubRoute: false,
            icon: "table-plus",
            base: "maps",
            materialicons: "people",
            submenuItems: [
              {
                label: "Leaflets",
                link: routes.mapLeaflet,
                base: "leaflets",
              },
            ],
          },
        ],
      },
      {
        tittle: "Extras",
        icon: "file",
        showAsTab: false,
        separateRoute: false,
        submenuItems: [
          {
            label: "Documentation",
            submenu: false,
            showSubRoute: false,
            icon: "file-text",
            base: "1",
            materialicons: "description",
            submenuItems: [],
          },
          {
            label: "Change Log",
            changeLogVersion: true,
            submenu: false,
            showSubRoute: false,
            icon: "exchange",
            base: "1",
            materialicons: "sync_alt",
            submenuItems: [],
          },
        ],
      },
      {
        tittle: "Configuration",
        icon: "file",
        showAsTab: false,
        separateRoute: false,
        submenuItems: [
          {
            label: "Whatsapp",
            submenu: false,
            showSubRoute: false,
            icon: "brand-whatsapp",
            materialicons: "brand-whatsapp",
            link: routes.whatsappConfigurations,
          },
          {
            label: "Email Templates",
            submenu: false,
            showSubRoute: false,
            icon: "mail",
            materialicons: "mail",
            link: routes.emailTemplates,
          },
          {
            label: "Configuration",
            link: routes.configuration,
            submenu: false,
            showSubRoute: false,
            icon: "settings",
            base: "config",
            materialicons: "request_quote",
            submenuItems: [],
          },
        ],
      },
    ];
  } else {
    return [];
  }
};
